import $ from 'jquery';

class Settings {

    constructor() {
        $(document.body).on('change', '.gpay-button-option', this.updateButton.bind(this));
        this.init();
    }

    init() {
        this.paymentsClient = new google.payments.api.PaymentsClient({environment: 'TEST'});
        this.updateButton();
    }

    updateButton() {
        this.$button?.remove();
        this.$button = $(this.paymentsClient.createButton({
            onClick() {},
            buttonColor: $('.button-color').val(),
            buttonType: $('.button-style').val(),
            buttonRadius: $('.button-radius').val(),
            buttonSizeMode: 'fill'
        }));
        this.$button.find('button').css({height: `${$('.button-height').val()}px`});
        $('#gpay-button').append(this.$button);
    }
}

new Settings();
